const keycloakConfig = {
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  url: process.env.REACT_APP_KEYCLOAK_AUTH_URL, // keycloak-js expects `url`
  sslRequired: process.env.REACT_APP_KEYCLOAK_SSL_REQUIRED,
  clientId: process.env.REACT_APP_KEYCLOAK_RESOURCE,
  publicClient: process.env.REACT_APP_KEYCLOAK_PUBLIC_CLIENT,
  confidentialPort: Number(process.env.REACT_APP_KEYCLOAK_CONFIDENTIAL_PORT),
};

export default keycloakConfig;